import React, { useMemo } from 'react';
import type {
  TaskWithPopulatedAssignees,
  BaseIssue,
  IssueAssignee,
  TaskIssue,
} from '@momentum/types';
import { TaskRow } from '@/shared/components/tasks/TaskRow';

interface GoalTaskRowProps {
  task: TaskWithPopulatedAssignees;
  currentEmployeeId?: string;
}

export const GoalTaskRow: React.FC<GoalTaskRowProps> = ({
  task,
  currentEmployeeId,
}) => {
  // Parse the task to separate populated assignees from the base task
  const { baseTask, assignees } = useMemo(() => {
    const populatedAssignees: IssueAssignee[] = task.assignees;
    const assigneeIds = populatedAssignees?.map((a) => a._id);

    const parsedTask: BaseIssue = {
      ...task,
      assignees: assigneeIds,
    };

    return {
      baseTask: parsedTask,
      assignees: populatedAssignees,
    };
  }, [task]);

  return (
    <TaskRow
      task={baseTask as TaskIssue}
      assignees={assignees}
      currentEmployeeId={currentEmployeeId}
    />
  );
};
